import { render, staticRenderFns } from "./IpWhitelist.vue?vue&type=template&id=3950baa2&"
import script from "./IpWhitelist.vue?vue&type=script&lang=ts&"
export * from "./IpWhitelist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports